import { CASALE } from "@/data/questionnaire";

export const Shell = ({ children, wide = false, header }) => (
  <div className={`relative z-10 mx-auto px-5 sm:px-8 py-8 sm:py-12 ${wide ? "max-w-5xl" : "max-w-3xl"}`}>
    {header !== null && (
      <header className="mb-8 sm:mb-10 flex flex-wrap items-baseline justify-between gap-4">
        <div>
          <p className="eyebrow">Questionario</p>
          <p className="font-serif text-2xl sm:text-3xl font-semibold text-[#2C221E]" data-testid="casale-name">{CASALE.name}</p>
        </div>
        {header}
      </header>
    )}
    {children}
  </div>
);
